<template>
  <div id="EstelamCheck" class="container bnp-ec" dir="rtl">
    <loading v-if="renderLoading"></loading>

    <panel
      Title="استعلام و ثبت چک"
      :Des="PageDescription"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right"
    ></panel>

    <net-pa-card :Classes="'success'">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-money-check"></i> استعلام و ثبت چک
        </h6>
      </template>

      <template slot="content">
        <!-- استعلام -->
        <div class="bnp-ec-search">
          <div class="bnp-ec-field bnp-ec-search__input">
            <label for="ecSayadId" class="bnp-ec-label">شناسه صیادی چک</label>
            <input
              id="ecSayadId"
              v-model="Data.sayadId"
              type="text"
              dir="ltr"
              inputmode="numeric"
              autocomplete="off"
              maxlength="16"
              placeholder="شناسه ۱۶ رقمی صیادی"
              class="form-control bnp-ec-control bnp-ec-control--code"
              @keypress="$ValidNumber($event, 16)"
              @keyup.enter="Estelam"
            />
            <small class="bnp-ec-help">شناسه صیادی ۱۶ رقمی درج‌شده روی برگه چک را وارد کنید.</small>
          </div>
          <button
            type="button"
            class="bnp-ec-btn bnp-ec-btn--primary bnp-ec-search__btn"
            :disabled="renderLoading || !Data.sayadId"
            @click="Estelam"
          >
            <i class="fas fa-search" aria-hidden="true"></i>
            {{ renderLoading ? 'در حال بررسی...' : 'استعلام' }}
          </button>
        </div>

        <!-- نتیجه استعلام -->
        <div v-if="ChequeData != null" class="bnp-ec-result">
          <section class="bnp-ec-section">
            <div class="bnp-ec-section__head">
              <div class="bnp-ec-section-title">
                <i class="fas fa-file-invoice" aria-hidden="true"></i>
                مشخصات چک
              </div>
              <span class="bnp-ec-status" :class="'bnp-ec-status--' + StatusTone">
                <i :class="StatusIcon" aria-hidden="true"></i>
                {{ ChequeData.chequeStatus }}
              </span>
            </div>

            <dl class="bnp-ec-tiles">
              <div
                v-for="row in ChequeRows"
                :key="row.key"
                class="bnp-ec-tile"
                :class="{ 'bnp-ec-tile--wide': row.wide }"
              >
                <dt>{{ row.label }}</dt>
                <dd :dir="row.ltr ? 'ltr' : null" :class="{ 'bnp-ec-ltr': row.ltr, 'bnp-ec-strong': row.strong }">
                  {{ row.value === '' || row.value == null ? '—' : row.value }}
                </dd>
              </div>
            </dl>
          </section>

          <!-- تأیید / رد چک -->
          <section v-if="CanAcceptCheque" class="bnp-ec-section">
            <div class="bnp-ec-section-title">
              <i class="fas fa-user-check" aria-hidden="true"></i>
              تأیید / رد چک
            </div>
            <p class="bnp-ec-note">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
              این چک در انتظار تأیید شماست. پس از بررسی مشخصات، چک را تأیید یا رد کنید.
            </p>
            <div class="bnp-ec-grid">
              <div class="bnp-ec-field bnp-ec-field--span2">
                <label for="ecAcceptDescription" class="bnp-ec-label">توضیحات</label>
                <input
                  id="ecAcceptDescription"
                  v-model="DataAcceptCheque.acceptDescription"
                  type="text"
                  placeholder="توضیحات (اختیاری)"
                  class="form-control bnp-ec-control"
                />
              </div>
              <div class="bnp-ec-actions">
                <button
                  type="button"
                  class="bnp-ec-btn bnp-ec-btn--success"
                  :disabled="renderLoading"
                  @click="SetChequeAccept('accept')"
                >
                  <i class="fas fa-check" aria-hidden="true"></i>
                  تأیید چک
                </button>
                <button
                  type="button"
                  class="bnp-ec-btn bnp-ec-btn--danger"
                  :disabled="renderLoading"
                  @click="SetChequeAccept('reject')"
                >
                  <i class="fas fa-times" aria-hidden="true"></i>
                  رد چک
                </button>
              </div>
            </div>
          </section>

          <!-- ثبت چک در حساب -->
          <section class="bnp-ec-section">
            <div class="bnp-ec-section-title">
              <i class="fas fa-folder-plus" aria-hidden="true"></i>
              ثبت چک در حساب
            </div>
            <p class="bnp-ec-help bnp-ec-help--lead">برای ثبت چک در حساب، یکی از حساب‌های خود را انتخاب کنید.</p>

            <div class="bnp-ec-grid">
              <div class="bnp-ec-field">
                <label for="ecBank" class="bnp-ec-label">بانک چک</label>
                <SelectCombo
                  id="ecBank"
                  class="bnp-ec-control"
                  :key="'bank-' + (selectedBankName || '')"
                  @result="getSelectedBank"
                  :readFromAction="'SelAzaHesab/GetBanks'"
                  :defaultItemText="selectedBankName"
                ></SelectCombo>
              </div>
              <div class="bnp-ec-field">
                <label for="ecShobe" class="bnp-ec-label">نام شعبه بانک</label>
                <input id="ecShobe" type="text" v-model="DataSarHesab.ShobeChk" placeholder="نام شعبه" class="form-control bnp-ec-control" />
              </div>
              <div class="bnp-ec-field">
                <label for="ecSaheb" class="bnp-ec-label">نام صاحب چک (صادرکننده)</label>
                <input id="ecSaheb" type="text" v-model="DataSarHesab.SahebCheck" placeholder="نام صاحب چک" class="form-control bnp-ec-control" />
              </div>
              <div class="bnp-ec-field">
                <label for="ecSahebMeli" class="bnp-ec-label">کد ملی صاحب چک (صادرکننده)</label>
                <input
                  id="ecSahebMeli"
                  type="text"
                  dir="ltr"
                  inputmode="numeric"
                  v-model="DataSarHesab.CodeMeliSahebCheck"
                  placeholder="کد ملی صاحب چک"
                  class="form-control bnp-ec-control bnp-ec-control--code"
                />
              </div>
              <div class="bnp-ec-field">
                <label for="cmbTaahodat" class="bnp-ec-label">حساب مقصد</label>
                <select name="cmbTaahodat" id="cmbTaahodat" class="form-control bnp-ec-control Pointer" v-model="DataSarHesab.WwwtblTaahodatId">
                  <option disabled :value="null">-- یکی از حساب‌های خود را انتخاب کنید --</option>
                  <option v-for="item in ListTaahodat" :key="item.id" :value="item.id">
                    {{ item.vcodeDesNo }} {{ item.nameFamily }}
                  </option>
                </select>
              </div>
              <div class="bnp-ec-field">
                <label for="ecTozihat" class="bnp-ec-label">توضیحات</label>
                <input id="ecTozihat" type="text" v-model="DataSarHesab.Tozihat" placeholder="توضیحات (اختیاری)" class="form-control bnp-ec-control" maxlength="1500" />
              </div>
            </div>

            <div class="bnp-ec-footer">
              <button type="button" class="bnp-ec-btn bnp-ec-btn--primary bnp-ec-btn--wide" :disabled="renderLoading" @click="AddChequeSarHesab">
                <i class="fas fa-save" aria-hidden="true"></i>
                ثبت چک
              </button>
            </div>
          </section>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import Loading from '../Tools/NetPa/Loading.vue'
import SelectCombo from '@/components/Tools/SelectCombo.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Panel from '../Tools/NetPa/Panel.vue'
export default {
  components: { Loading, NetPaCard, SelectCombo, Panel },
  data() {
    return {
      renderLoading: false,
      Data: {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BankId: 'BSI',
          ClientId: 'NUFd137XKt',
          ClientSecret: 'i8UoHX9IWd',
        },
        bank: 'BSI',
        sayadId: '',
        idCode: '',
        idTypes: 'legalCustomer',
      },
      Token: '',
      Hazine: 0,
      ChequeData: null,
      originalChequeStatus: '',
      CanAcceptCheque: false,
      ListTaahodat: [],
      DataAcceptCheque: {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BankId: 'BSI',
          ClientId: 'NUFd137XKt',
          ClientSecret: 'i8UoHX9IWd',
        },
        bank: 'BSI',
        sayadId: '',
        acceptor: {
          idCode: '',
          idTypes: 'legalCustomer',
        },
        acceptorAgent: {
          idCode: '',
          idTypes: 'realCustomer',
        },
        accepts: '',
        acceptDescription: '',
      },
      DataSarHesab: {
        Id: 11,
        BnpCashDbtblChkSareHesabId: null,
        WwwtblTaahodatId: null,
        Wwwtblshobeid: null,
        SerialChk: null,
        ShobeChk: null,
        ShHesabChk: null,
        TblBankId: null,
        TblComboIdVaziyatChk8: null,
        MablaghChk: null,
        TarixChk: null,
        TarixDaryaft: null,
        CodeShobe: null,
        City: null,
        Moshaxasat: null,
        SahebCheck: null,
        IsBargashtShode: null,
        DateTimeInsert: null,
        IsApproved: null,
        Seri: null,
        CodeMeliSahebCheck: '',
        Tozihat: '',
      },
      Bank: null,
      selectedBankName: '',
    }
  },
  computed: {
    PageDescription() {
      return 'این سامانه تنها قادر به بررسی و استعلام چک‌هایی است که در وجه [' + (this.$session.get('NameSandogh') || '') + '] صادر شده‌اند.'
    },
    StatusTone() {
      switch (this.originalChequeStatus) {
        case 'registeredReceiverApproval':
        case 'criticized':
          return 'success'
        case 'voided':
        case 'returned':
        case 'partReturned':
          return 'danger'
        case 'waitingSignatureGuarantor':
        case 'waitingRecipientConfirmWithdrawalCheck':
        case 'waitingRecipientConfirmTransferCheck':
          return 'warning'
        default:
          return 'info'
      }
    },
    StatusIcon() {
      return {
        success: 'fas fa-check-circle',
        danger: 'fas fa-exclamation-circle',
        warning: 'fas fa-hourglass-half',
        info: 'fas fa-info-circle',
      }[this.StatusTone]
    },
    ChequeRows() {
      const c = this.ChequeData || {}
      const holder = c.holders && c.holders.length ? c.holders[0] : null
      return [
        { key: 'sayadId', label: 'شناسه صیاد', value: c.sayadId, ltr: true },
        { key: 'serial', label: 'سری / سریال چک', value: (c.serialNo || '') + ' / ' + (c.seriesNo || ''), ltr: true },
        { key: 'amount', label: 'مبلغ چک', value: c.amount != null ? this.$Comma3ragham(c.amount) + ' ' + this.$GetVahedPool() : '', strong: true },
        { key: 'dueDate', label: 'تاریخ چک', value: c.dueDate },
        { key: 'bankName', label: 'نام بانک', value: c.bankName },
        { key: 'chequeType', label: 'نوع چک', value: c.chequeType },
        { key: 'chequeMedia', label: 'بستر چک', value: c.chequeMedia },
        { key: 'fromIban', label: 'شناسه شبای چک', value: c.fromIban, ltr: true, wide: true },
        { key: 'holder', label: 'گیرنده', value: holder ? [holder.name, holder.idCode, holder.idTypes].filter(Boolean).join(' - ') : '', wide: true },
        { key: 'description', label: 'بابت', value: c.description, wide: true },
      ]
    },
  },
  methods: {
    GetShenaseMeli() {
      this.$PostData({ Action: 'Tanzimat', ArryfildValue: null, Method: 'GET', Token: this.$session.get('TokenNetPa') /* NetPa HANDOFF P1-4 : ghablan 'Tanzim`at' (backtick) */ }).then((result) => {
        this.Data.idCode = result[0].shenaseMeli.trim()
        this.DataAcceptCheque.acceptor.idCode = result[0].shenaseMeli.trim()
      })
    },
    normalizeBankName(name) {
      return (name || '')
        .replace(/ي/g, 'ی')
        .replace(/ك/g, 'ک')
        .replace(/\s+/g, ' ')
        .trim()
    },
    setBankFromName(bankName) {
      this.Bank = null
      this.selectedBankName = bankName || ''
      if (!bankName) return

      this.$PostData_new('SelAzaHesab/GetBanks', 'get').then((banks) => {
        if (!banks || !banks.length) return

        const target = this.normalizeBankName(bankName)
        let bank = banks.find((x) => this.normalizeBankName(x.name) === target)
        if (!bank) {
          bank = banks.find((x) => {
            const name = this.normalizeBankName(x.name)
            return name.includes(target) || target.includes(name)
          })
        }
        if (bank) {
          this.Bank = bank.bnpcashDbId
          this.selectedBankName = bank.name
        }
      })
    },
    Estelam() {
      if (!this.Data.sayadId || this.renderLoading) return
      this.renderLoading = true
      this.CanAcceptCheque = false
      this.ChequeData = null
      this.Bank = null
      this.selectedBankName = ''
      this.$PostData_netpatoken({ action: 'EstelamCheq', arryfildValue: this.Data, method: 'POST' })
        .then((result) => {
          if (result.errorCode) {
            this.$mySweetDefault('خطا', result.message, 'error', 2000)
          } else {
            result.respObject.dueDate = result.respObject.dueDate.substring(0, 4) + '/' + result.respObject.dueDate.substring(4, 6) + '/' + result.respObject.dueDate.substring(6, 8)
            if (result.transactionState && result.transactionState == 'SUCCESS') {
              this.ChequeData = result.respObject
              this.originalChequeStatus = this.ChequeData.chequeStatus
              this.CanAcceptCheque =
                this.originalChequeStatus == 'waitingRecipientConfirmTransferCheck' ||
                this.originalChequeStatus == 'waitingRecipientConfirmWithdrawalCheck'
              this.DataAcceptCheque.sayadId = this.ChequeData.sayadId
              this.DataAcceptCheque.acceptorAgent.idCode = this.$session.get('UserInfoNetPa').codeMeli.trim()
              this.DataAcceptCheque.acceptorAgent.idTypes = 'realCustomer'
              this.setBankFromName(this.ChequeData.bankName)

              switch (this.ChequeData.chequeStatus) {
                case 'registeredReceiverApproval':
                  this.ChequeData.chequeStatus = 'ثبت شده با تأیید گیرنده'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 4114
                  break

                case 'criticized':
                  this.ChequeData.chequeStatus = 'نقد شده'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 4022
                  break

                case 'voided':
                  this.ChequeData.chequeStatus = 'باطل شده'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 4102
                  break

                case 'returned':
                  this.ChequeData.chequeStatus = 'برگشت خورده'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 4024
                  break

                case 'partReturned':
                  this.ChequeData.chequeStatus = 'بخشی برگشت خورده'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 4024
                  break

                case 'waitingSignatureGuarantor':
                  this.ChequeData.chequeStatus = 'در انتظار ضامن'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 43115
                  break

                case 'waitingRecipientConfirmWithdrawalCheck':
                  this.ChequeData.chequeStatus = 'در انتظار تأیید گیرنده در کشیدن چک'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 43115
                  break

                case 'waitingRecipientConfirmTransferCheck':
                  this.ChequeData.chequeStatus = 'در انتظار تأیید گیرنده در انتقال چک'
                  this.DataSarHesab.TblComboIdVaziyatChk8 = 43115
                  break

                default:
                  break
              }
              switch (this.ChequeData.chequeType) {
                case 'normal':
                  this.ChequeData.chequeType = 'چک عادی'
                  break

                case 'bank':
                  this.ChequeData.chequeType = ' چک بانکی'
                  break

                case 'encrypted':
                  this.ChequeData.chequeType = 'چک رمزدار'
                  break

                default:
                  break
              }
              switch (this.ChequeData.chequeMedia) {
                case 'paperCheck':
                  this.ChequeData.chequeMedia = 'چک کاغذی'
                  break

                case 'digitalCheck':
                  this.ChequeData.chequeMedia = 'چک دیجیتال'
                  break

                default:
                  break
              }
              if (this.ChequeData.holders[0].idTypes == 'realCustomer') this.ChequeData.holders[0].idTypes = 'حقیقی ایرانی'
              else if (this.ChequeData.holders[0].idTypes == 'legalCustomer') this.ChequeData.holders[0].idTypes = 'حقوقی ایرانی'
              else if (this.ChequeData.holders[0].idTypes == 'realAliens') this.ChequeData.holders[0].idTypes = 'اتباع حقیقی'
              else if (this.ChequeData.holders[0].idTypes == 'legalAliens') this.ChequeData.holders[0].idTypes = 'اتباع بیگانه'
            }
          }
        })
        .finally(() => {
          this.renderLoading = false
        })
    },

    SetChequeAccept(acceptType) {
      this.renderLoading = true
      this.DataAcceptCheque.accepts = acceptType
      this.DataAcceptCheque.bank = 'BSI'
      this.DataAcceptCheque.acceptor.idTypes = 'legalCustomer'
      this.DataAcceptCheque.acceptorAgent.idTypes = 'realCustomer'
      this.DataAcceptCheque.acceptorAgent.idCode = this.$session.get('UserInfoNetPa').codeMeli.trim()
      this.$PostData_netpatoken({ action: 'EstelamCheq/SetChequeAccept', arryfildValue: this.DataAcceptCheque, method: 'POST' })
        .then((result) => {
          if (result && result.errorCode) {
            this.$mySweetDefault('خطا', result.message, 'error', 2000)
          } else if (result && result.transactionState == 'SUCCESS') {
            this.$mySweetDefault('موفق', acceptType == 'accept' ? 'چک با موفقیت تأیید شد' : 'چک با موفقیت رد شد', 'success', 2000)
            this.CanAcceptCheque = false
            this.renderLoading = false
            this.Estelam()
          } else {
            this.$mySweetDefault('خطا', 'عملیات با خطا مواجه شد', 'error', 2000)
          }
        })
        .finally(() => {
          this.renderLoading = false
        })
    },

    GetListTaahodat() {
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId)
      var DataAxios_cmbTaahodat = { ArryfildValue: formData, Method: 'Post', Action: 'ListTaahodat', Token: this.$session.get('TokenNetPa') }
      this.$PostFormData(DataAxios_cmbTaahodat).then((data) => {
        this.ListTaahodat = data.filter((x) => x.tblSarfaslTypeId != 6)
      })
    },
    AddChequeSarHesab() {
      if (this.DataSarHesab.WwwtblTaahodatId == null || this.DataSarHesab.WwwtblTaahodatId == '') {
        this.$mySweetDefault('خطا!', 'لطفا نام یکی از حساب‌های خود در ' + (this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق') + ' را انتخاب کنید', 'error', 2000)
      } else if (this.Bank == null || this.Bank == '') {
        this.$mySweetDefault('خطا!', 'لطفا بانک صادر کننده چک را انتخاب کنید', 'error', 2000)
      } else {
        this.DataSarHesab.Id = 11
        this.DataSarHesab.Wwwtblshobeid = this.$session.get('UserInfoNetPa').wwwtblShobeId
        this.DataSarHesab.SerialChk = this.ChequeData.serialNo
        this.DataSarHesab.Seri = this.ChequeData.seriesNo
        this.DataSarHesab.ShHesabChk = this.ChequeData.fromIban
        this.DataSarHesab.MablaghChk = this.ChequeData.amount
        this.DataSarHesab.SayadNo = this.ChequeData.sayadId
        this.DataSarHesab.TarixChk = this.ChequeData.dueDate
        this.DataSarHesab.TarixDaryaft = this.$GetJalaliDateTime().substring(0, 10)
        this.DataSarHesab.CodeShobe = this.ChequeData.branchCode
        this.DataSarHesab.Moshaxasat = this.$session.get('UserInfoNetPa').ozvFamily + ' ' + this.$session.get('UserInfoNetPa').ozvName
        this.DataSarHesab.DateTimeInsert = this.$GetJalaliDateTime()
        this.DataSarHesab.IsApproved = false
        this.DataSarHesab.IsBargashtShode = false
        this.DataSarHesab.TblBankId = this.Bank

        var dataAxiosAdd = { action: 'ChkSareHesabadd', method: 'POST', arryfildValue: this.DataSarHesab }
        this.$PostData_netpatoken(dataAxiosAdd).then((result) => {
          this.$mySweetDefault(result.title, result.msg, result.icon, 2000)
        })
      }
    },
    getSelectedBank(data) {
      this.Bank = data.bnpcashDbId
    },
  },
  created() {
    this.GetShenaseMeli()

    this.GetListTaahodat()
  },
}
</script>
<style scoped>
.bnp-ec {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-brand-blue: #287db4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-surface-accent: #edf7fb;
  --bnp-info-soft: #edf5fb;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-border-hover: #bdcbd4;
  --bnp-success: #05a895;
  --bnp-warning: #c48726;
  --bnp-warning-soft: #fff7e8;
  --bnp-danger: #b44f46;
  --bnp-danger-surface: #fcefed;
  --bnp-radius-md: 14px;
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;

  max-width: 1060px;
  padding-top: 4px;
  padding-bottom: 16px;
  color: var(--bnp-text-primary);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  text-align: right;
}

/* ---------- Search ---------- */
.bnp-ec-search {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.bnp-ec-search__input {
  flex: 0 1 420px;
}

.bnp-ec-search__btn {
  flex: 0 0 auto;
  min-width: 160px;
  margin-top: 26px;
}

/* ---------- Fields ---------- */
.bnp-ec-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.bnp-ec-label {
  display: block;
  margin-bottom: 6px;
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 700;
}

.bnp-ec-help {
  display: block;
  margin-top: 6px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  line-height: 1.8;
}

.bnp-ec-help--lead {
  margin: -4px 0 14px;
}

.bnp-ec-control {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 14px !important;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background-color: var(--bnp-surface-subtle);
  transition:
    border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-ec-control:hover {
  border-color: var(--bnp-border-hover);
}

.bnp-ec-control:focus {
  border-color: var(--bnp-focus-color);
  background-color: #fff;
  box-shadow: var(--bnp-focus-ring);
  outline: none;
}

.bnp-ec-control:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.bnp-ec-control::placeholder {
  color: #8a96a3;
}

.bnp-ec-control--code {
  font-weight: 700;
  letter-spacing: 0.06em;
  text-align: left;
}

.bnp-ec-control--code::placeholder {
  font-weight: 400;
  letter-spacing: normal;
  text-align: right;
}

.bnp-ec-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.bnp-ec-field--span2 {
  grid-column: span 2;
}

/* ---------- Sections ---------- */
.bnp-ec-result {
  margin-top: 20px;
}

.bnp-ec-section {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid var(--bnp-border-subtle);
}

.bnp-ec-section:first-child {
  margin-top: 0;
}

.bnp-ec-section__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  margin-bottom: 12px;
}

.bnp-ec-section__head .bnp-ec-section-title {
  margin-bottom: 0;
}

.bnp-ec-section-title {
  margin-bottom: 12px;
  color: var(--bnp-brand-navy);
  font-size: 15px;
  font-weight: 800;
}

.bnp-ec-section-title i {
  margin-left: 6px;
  color: var(--bnp-brand-blue);
}

/* ---------- Status badge ---------- */
.bnp-ec-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.6;
  border-radius: 999px;
}

.bnp-ec-status--success {
  color: #047a6c;
  background: rgba(5, 168, 149, 0.12);
}

.bnp-ec-status--warning {
  color: #8a5d12;
  background: var(--bnp-warning-soft);
}

.bnp-ec-status--danger {
  color: var(--bnp-danger);
  background: var(--bnp-danger-surface);
}

.bnp-ec-status--info {
  color: var(--bnp-brand-blue);
  background: var(--bnp-info-soft);
}

/* ---------- Info tiles ---------- */
.bnp-ec-tiles {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin: 0;
}

.bnp-ec-tile {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: 12px;
  background: var(--bnp-surface-subtle);
}

.bnp-ec-tile--wide {
  grid-column: 1 / -1;
}

.bnp-ec-tile dt {
  margin: 0 0 2px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.8;
}

.bnp-ec-tile dd {
  margin: 0;
  color: var(--bnp-text-primary);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  word-break: break-word;
}

.bnp-ec-tile dd.bnp-ec-ltr {
  text-align: right;
  unicode-bidi: plaintext;
}

.bnp-ec-tile dd.bnp-ec-strong {
  color: var(--bnp-brand-navy);
  font-size: 16px;
  font-weight: 800;
}

/* ---------- Note ---------- */
.bnp-ec-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 14px;
  padding: 8px 12px;
  color: var(--bnp-text-primary);
  font-size: 12px;
  line-height: 1.8;
  border-radius: 12px;
  background: var(--bnp-info-soft);
}

.bnp-ec-note i {
  margin-top: 5px;
  color: var(--bnp-brand-blue);
}

/* ---------- Buttons ---------- */
.bnp-ec-actions {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}

.bnp-ec-actions .bnp-ec-btn {
  flex: 1 1 0;
}

.bnp-ec-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.bnp-ec-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 48px;
  padding: 10px 22px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  border: 1px solid transparent;
  border-radius: var(--bnp-radius-md);
  outline: none;
  cursor: pointer;
  transition:
    transform var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease,
    border-color var(--bnp-motion-fast) ease;
}

.bnp-ec-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.bnp-ec-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.bnp-ec-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(110deg, var(--bnp-brand-navy), var(--bnp-brand-indigo) 58%, var(--bnp-brand-purple));
  box-shadow: var(--bnp-shadow-md);
}

.bnp-ec-btn--primary:hover:not(:disabled) {
  color: #fff;
  transform: translateY(-2px);
}

.bnp-ec-btn--wide {
  min-width: 200px;
}

.bnp-ec-btn--success {
  color: #047a6c;
  border-color: rgba(5, 168, 149, 0.35);
  background: rgba(5, 168, 149, 0.08);
}

.bnp-ec-btn--success:hover:not(:disabled) {
  color: #fff;
  background: var(--bnp-success);
  border-color: var(--bnp-success);
}

.bnp-ec-btn--danger {
  color: var(--bnp-danger);
  border-color: rgba(180, 79, 70, 0.35);
  background: var(--bnp-danger-surface);
}

.bnp-ec-btn--danger:hover:not(:disabled) {
  color: #fff;
  background: var(--bnp-danger);
  border-color: var(--bnp-danger);
}

/* ---------- Responsive ---------- */
@media (max-width: 991px) {
  .bnp-ec-grid,
  .bnp-ec-tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bnp-ec-field--span2 {
    grid-column: 1 / -1;
  }

  .bnp-ec-actions {
    grid-column: 1 / -1;
  }
}

@media (max-width: 575px) {
  .bnp-ec {
    padding-right: 8px;
    padding-left: 8px;
  }

  .bnp-ec-search {
    flex-direction: column;
    align-items: stretch;
  }

  .bnp-ec-search__input {
    flex: none;
  }

  .bnp-ec-search__btn {
    width: 100%;
    margin-top: 0;
  }

  .bnp-ec-grid,
  .bnp-ec-tiles {
    grid-template-columns: minmax(0, 1fr);
  }

  .bnp-ec-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .bnp-ec-footer .bnp-ec-btn {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .bnp-ec-control,
  .bnp-ec-btn {
    transition: none;
  }

  .bnp-ec-btn--primary:hover:not(:disabled) {
    transform: none;
  }
}
</style>
